import { extendTheme } from "@chakra-ui/react";
import { buttonVariants } from "./buttonVariants";
import { colors } from "./colors";
import textStyles from "./textStyles";

const customTheme = extendTheme({
  config: {
    initialColorMode: "light",
    useSystemColorMode: false,
  },
  breakpoints: {
    xs: "350px",
    sm: "480px",
    md: "768px",
    lg: "992px",
    xl: "1280px",
    "2xl": "1536px",
    "3xl": "1920px",
    "4xl": "2560px",
    "5xl": "3840px",
  },
  fonts: {
    heading: "Inter, sans-serif",
    body: "Inter, sans-serif",
  },
  colors: colors,
  styles: {
    global: (props: any) => ({
      body: {
        bg: props.colorMode === "dark" ? "dark" : "white",
        color: props.colorMode === "dark" ? "wt" : "black",
      },
      "::-webkit-scrollbar": {
        width: "4px",
        height: "4px",
      },
      "::-webkit-scrollbar-track": {
        background: props.colorMode === "light" ? "#D4D4D4" : "#2C2C2C",
      },
      "::-webkit-scrollbar-thumb": {
        background: props.colorMode === "light" ? "#A8A8A8" : "#505050",
        borderRadius: "24px",
      },
    }),
  },

  components: {
    Text: {
      variants: {
        secondary: {
          opacity: 0.6,
        },
      },
    },
    Button: {
      baseStyle: {
        borderRadius: "md",
        // borderRadius: ["xs", "sm", null, "md"],
      },
      defaultProps: {
        size: ["sm", "sm", "sm", "sm", "md"],
      },
      variants: buttonVariants,
    },
    Form: {
      parts: ["container", "requiredIndicator", "helperText"],
      baseStyle: {
        container: {
          label: {
            fontSize: [10, null, 12],
          },
        },
      },
    },
    FormError: {
      baseStyle: {
        text: {
          fontSize: [12, null, 14],
        },
      },
    },
    Link: {
      variants: {
        linkPrimary: {
          // color: "red.400",
          fontWeight: "semibold",
          textDecoration: "none",
          _hover: { textDecoration: "none" },
        },
      },
    },
    Input: {
      variants: {
        outline: (props: any) => ({
          field: {
            borderColor:
              props.colorMode === "light"
                ? "gray.300"
                : "RGBA(255, 255, 255, 0.24)",
            _focus: {
              borderColor:
                props.colorMode === "light" ? "blue.500" : "blue.300",
              boxShadow: "0 0 0 1px var(--chakra-colors-blue-500)",
              _dark: {
                boxShadow: "0 0 0 1px var(--chakra-colors-blue-300)",
              },
            },
          },
        }),
      },
      baseStyle: {
        field: {
          borderRadius: "md",

          _placeholder: {
            fontSize: ["xs", null, "sm"],
          },
        },
      },
      defaultProps: {
        size: ["sm", null, "md"],
        variant: "outline",
      },
    },
    Modal: {
      baseStyle: (props: any) => ({
        dialog: {
          bg: props.colorMode === "dark" ? "black" : "white",
        },
        footer: {
          gap: 3,
        },
        overlay: {
          backdropFilter: "blur(2px)",
          bg: "rgba(0, 0, 0, 0.6)",
        },
        header: {
          fontSize: [14, null, 16],
          fontWeight: "semibold",
        },
      }),
    },
    Drawer: {
      baseStyle: (props: any) => ({
        dialog: {
          bg: props.colorMode === "dark" ? "black" : "white",
          borderTopLeftRadius: "xl",
          borderTopRightRadius: "xl",
        },
        overlay: {
          backdropFilter: "blur(2px)",
          bg: "rgba(0, 0, 0, 0.6)",
        },
        footer: {
          gap: 3,
        },
        header: {
          fontSize: [14, null, 16],
          fontWeight: "semibold",
        },
      }),
    },
    Toast: {
      defaultProps: {
        duration: 2000,
        isClosable: true,
      },
    },
    Select: {
      variants: {
        outline: {
          field: {
            size: ["sm", null, "md"],
            borderRadius: "md",
          },
        },
      },
      defaultProps: {
        variant: "outline",
        size: ["sm", null, "md"],
      },
    },
    Table: {
      baseStyle: {
        th: {
          fontSize: ["10px", null, "12px"],
        },
        td: {
          fontSize: ["10px", null, "12px"],
        },
      },
    },
  },
  textStyles: textStyles,
});

export default customTheme;
